import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-falg-fill 445",
  "use": "icon-falg-fill 445-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-falg-fill 445\"><path d=\"M256 138.666667v746.666666H192v-746.666666h64z m588.544 0L644.544 341.333333l200 202.666667H298.666667v-405.333333h545.877333z\" p-id=\"27983\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol